module.exports = __webpack_public_path__ + "static/img/icon10.45fdfa7b.png";